import React, { useState } from 'react'

import Flex from '@/components/shared/ui/Flex'
import { confirmPasswordAndSignin } from '@/models/Auth'

import { useTranslations } from '../../../hooks/useTranslations'
import { stateKeyValueChange } from '../../../lib/helpers/appHelpers'
import type { IConfirmPasswordData } from '../../../types/auth'
import toaster from '../../../utils/toast'
import Button from '../../shared/ui/Button'
import Input from '../../shared/ui/Input'
import PasswordRuleHintPopover from '../shared/PasswordRuleHintPopover'

interface IPropTypes {
  redirectTo?: string
  confirmationToken: string
}
export default function AuthConfirmPassword({
  redirectTo,
  confirmationToken,
}: IPropTypes) {
  const t = useTranslations('auth')

  const [loginData, setLoginData] = useState<IConfirmPasswordData>({
    confirmationToken,
  })
  const [loading, setLoading] = useState(false)

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const { password_confirmation, password } = loginData
    if (loading || !password_confirmation?.length || !password?.length)
      return null
    setLoading(true)
    return confirmPasswordAndSignin({ ...loginData })
      .then(() => {
        window.location.href = redirectTo || `${window.location.origin}/`
      })
      .catch(toaster.error)
      .finally(() => setLoading(false))
  }

  return (
    <form
      data-testid='auth_confirm_password_form'
      onSubmit={handleSubmit}
      className='space-y-3 py-4'
    >
      <div className='grid gap-4 p-6'>
        <Input
          dataTestId='password_input'
          type='password'
          value={loginData.password || ''}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            stateKeyValueChange('password', e.target.value, setLoginData)
          }}
          required
          placeholder={t('fields.createPassword.placeholder')}
        />
        <Input
          dataTestId='password_confirmation_input'
          type='password'
          value={loginData.password_confirmation || ''}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            stateKeyValueChange(
              'password_confirmation',
              e.target.value,
              setLoginData
            )
          }}
          required
          placeholder={t('fields.confirmPassword.placeholder')}
        />
        <Flex justify='end'>
          <PasswordRuleHintPopover />
        </Flex>
        <Button
          dataTestId='password_activate_button'
          className='w-full justify-center py-2.5'
          type='submit'
          disabled={loading}
          loading={loading}
        >
          Activate
        </Button>
      </div>
    </form>
  )
}
